import { css, cx } from "@emotion/css";
import { MenuItem } from "@material-ui/core";
import { space } from "@octopusdeploy/design-system-tokens";
import type { PropsWithChildren } from "react";
import React from "react";
export interface MenuItemInformationProps {
    compact?: boolean;
}
export function MenuItemInformation({ children, compact }: PropsWithChildren<MenuItemInformationProps>) {
    const classes = cx(menuItemStyles, compact ? compactMenuItemStyles : nonCompactMenuItemStyles);
    return (<MenuItem component={"div"} role={"none"} disabled={true} className={classes}>
            {children}
        </MenuItem>);
}
MenuItemInformation.displayName = "MenuItemInformation";
const menuItemStyles = css({
    "&.MuiMenuItem-root": {
        // These information items aren't quite like single line buttons, but can instead have wrapping text content
        whiteSpace: "inherit",
        "&.Mui-disabled": {
            // Material UI sets a lower opacity on the menu items if they are disabled.
            // In this case, we don't really have anything that is "disabled" so we opt out of this style
            opacity: "inherit",
            "&.MuiButtonBase-root": {
                // Allow normal pointer events because we aren't trying to prevent button clicks, text selection, etc.
                pointerEvents: "inherit",
            },
        },
        "&.MuiListItem-button": {
            // Allow text selection, because why not?
            userSelect: "inherit",
            "&:hover": {
                backgroundColor: "inherit",
            },
        },
    },
});
const compactMenuItemStyles = css({
    "&.MuiMenuItem-root": {
        minHeight: "auto",
    },
});
const nonCompactMenuItemStyles = css({
    "&.MuiMenuItem-root": {
        minHeight: space[8], // copied from material-ui's base styles, that would otherwise be overriden by a media query
    },
});
//We need this to make the title tooltip to appear for disabled items, this needs to be as specific as possible
//to override MUI internal styles taking precedence
const disabledMenuItemStyles = css({
    "&.MuiMenuItem-root": {
        "&.Mui-disabled": {
            pointerEvents: "auto",
        },
    },
});
